"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Us = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 7410 3900", ...props },
    react_1.default.createElement("path", { fill: "#b22234", d: "M0 0h7410v3900H0z" }),
    react_1.default.createElement("path", { stroke: "#fff", strokeWidth: 300, d: "M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0" }),
    react_1.default.createElement("path", { fill: "#3c3b6e", d: "M0 0h2964v2100H0z" }),
    react_1.default.createElement("g", { fill: "#fff" },
        react_1.default.createElement("g", { id: "us_svg__d" },
            react_1.default.createElement("g", { id: "us_svg__c" },
                react_1.default.createElement("g", { id: "us_svg__e" },
                    react_1.default.createElement("g", { id: "us_svg__b" },
                        react_1.default.createElement("path", { id: "us_svg__a", d: "m247 90 70.534 217.082-184.66-134.164h228.253L176.466 307.082z" }),
                        react_1.default.createElement("use", { xlinkHref: "#us_svg__a", y: 420 }),
                        react_1.default.createElement("use", { xlinkHref: "#us_svg__a", y: 840 }),
                        react_1.default.createElement("use", { xlinkHref: "#us_svg__a", y: 1260 })),
                    react_1.default.createElement("use", { xlinkHref: "#us_svg__a", y: 1680 })),
                react_1.default.createElement("use", { xlinkHref: "#us_svg__b", x: 247, y: 210 })),
            react_1.default.createElement("use", { xlinkHref: "#us_svg__c", x: 494 })),
        react_1.default.createElement("use", { xlinkHref: "#us_svg__d", x: 988 }),
        react_1.default.createElement("use", { xlinkHref: "#us_svg__c", x: 1976 }),
        react_1.default.createElement("use", { xlinkHref: "#us_svg__e", x: 2470 }))));
exports.default = Us;
//# sourceMappingURL=Us.js.map